import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VehicleDetails from "./pages/VehicleDetails";
import Favorites from "./pages/Favorites";
import VehicleComparison from "./pages/VehicleComparison";
import Vehicle from "./pages/Vehicle";
import "./App.css";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./i18n";
import { uiConfigAll } from "./redux/UiConfigurationSlice";
import Preloader from "./components/Preloader";
import NotFound from "./pages/NotFound";
import { culture } from "./constants/common-constants";
import { criteriaAll } from "./redux/CriteriaSlice";

function App() {
  //eslint-disable-next-line
  const [loading, setLoading] = useState(true);
  const spinnerAddedRef = useRef(false);
  const dispatch = useDispatch();
  const {
    uiConfigData = false,
    imprintUrl = false,
    privacyUrl = false,
    theme = false,
    loading: uiConfigLoading = false,
  } = useSelector((state) => state?.uiConfig) || {};
  const { criteriaAll: criteriaAllRes = [], loading: criteriaLoading = false } =
    useSelector((state) => state?.criteria) || {};

  useEffect(() => {
    if (criteriaAllRes?.length === 0 && !criteriaLoading) {
      dispatch(criteriaAll());
    }
  }, [dispatch, criteriaAllRes, criteriaLoading]);

  useEffect(() => {
    if (uiConfigData === false && !uiConfigLoading) {
      dispatch(uiConfigAll());
    }
  }, [dispatch, uiConfigData, uiConfigLoading]);

  const [isValidApiKeyAndUrl, setIsValidApiKeyAndUrl] = useState(false);

  useEffect(() => {
    const handlePageLoad = () => {
      setLoading(false);
    };
    window.addEventListener("load", handlePageLoad);
    return () => window.removeEventListener("load", handlePageLoad);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Function to dynamically load a script
    document.documentElement.lang = culture;
    const loadScript = (src) => {
      if (!document.querySelector(`script[src="${src}"]`)) {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        document.body.appendChild(script);
      }
    };

    loadScript("https://cdn.dein.auto/pxc-os-loader/pxc-os-loader.js");
  }, []);

  useEffect(() => {
    if (localStorage.getItem("persist:root")) {
      let localStorageApiKey = JSON.parse(
        JSON.parse(localStorage.getItem("persist:root"))?.criteria,
      )?.storeApiKey;
      const rootElementApiKey = document
        ?.getElementById("am-marketplace")
        ?.getAttribute("apikey");
      if (localStorageApiKey !== rootElementApiKey) {
        localStorage.removeItem("persist:root");
        window.location.reload();
      }
    }
  }, []);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const view = queryParams.get("view");

  useEffect(() => {
    if (spinnerAddedRef.current) return; // Prevent duplicate execution
    const ele = document.getElementById("am-marketplace");
    if (ele) {
      setIsValidApiKeyAndUrl(true);
      setLoading(true);
    }
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const renderPage = () => {
    switch (view) {
      case "vehicle-details":
        return <VehicleDetails />;
      case "favorites":
        return <Favorites />;
      case "vehicle-comparison":
        return <VehicleComparison />;
      case "vehicles":
        return <Vehicle />;
      case "not-found":
        return <NotFound />;
      default:
        return (
          isValidApiKeyAndUrl && <Vehicle domainName={theme?.companyName} />
        );
    }
  };

  return (
    <>
      {loading && <Preloader />}
      <div className="text-[var(--text-dark-mode)] bg-[var(--whitesmoke-color)]">
        <ToastContainer className="Toast_container" />
        {renderPage()}
        <pxc-os-settings
          api-key={document
            ?.getElementById("am-marketplace")
            ?.getAttribute("apikey")}
          urls-imprint={imprintUrl}
          urls-privacy={privacyUrl}
        />
      </div>
    </>
  );
}

export default App;
